module.exports = __webpack_public_path__ + "img/aurora.504c0c6f.png";